import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: 'briefing-preview',
    template: `
        <iframe *ngIf="visible && briefingId"
                (load)="loaded = true" 
                width="99%" 
                height="500" 
                seamless="seamless" 
                [src]="briefingUrl"></iframe>
        <spinner *ngIf="!loaded"></spinner>
    `
})
export class BriefingPreviewComponent implements OnInit {
    @Input() briefingId: string;
    @Input() visible: boolean;
    loaded = false;
    briefingUrl: any;
    
    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.briefingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`/ws/ua/briefings/${this.briefingId}/preview`);
    }
}